<template>
  <div class="sports_rank">

    <div class="myinfo">
      <div>
        <div class="myavatar">
          <VanImage :src="myinfo.avatar" />
        </div>
        <div class="myrank">
          <template v-if="+myinfo.rank > 0">第 {{ myinfo.rank }} 名</template>
          <template v-else>暂无排名</template>
        </div>
      </div>
      <div>
        <div>{{myinfo.totalscore}} 分</div>
      </div>
    </div>

    <List
      style="color:#FFF;"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getRankList"
    >
      <div class="rank-list">
        <CellGroup :style="`border-radius:${borderRadius}`" v-if="rankList.length" :border="false">
          <Cell v-for="item in rankList" :key="item.groupid" center  class="rank">
             <div slot="title">{{item.name||item.nickname}}</div>
              <div slot="icon" class="rank_icon">
                <template v-if="item.rank <= 3">
                  <img src="@/assets/img/rank/1.png" :alt="item.rank" v-if="item.rank == 1" />
                  <img src="@/assets/img/rank/2.png" :alt="item.rank" v-if="item.rank == 2" />
                  <img src="@/assets/img/rank/3.png" :alt="item.rank" v-if="item.rank == 3" />
                </template>
                <span v-else>{{ item.rank }}</span>
                <VanImage :src="item.avatarurl" />
              </div>

            <span style="color: rgba(0, 146, 229, 1);">{{ item.totalscore*1 }} 分</span>
          </Cell>
        </CellGroup>
        <Empty
          style="background: #fff;min-height: 6rem"
          :style="`border-radius: ${borderRadius}`"
          v-else
          description="暂无数据"
        />
      </div>
    </List>
  </div>
</template>

<style lang="less" scoped>
@import "./index.less";

.filter {
  width: 6.9rem;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .item {
    font-size: 0.3rem;
    padding: 0.12rem 0;
    width: 2rem;
    display: flex;
    justify-content: center;
    border-radius: 0.2rem 0.2rem 0 0;

    &.active {
      background: #fff;
      color: #333;
    }
  }
}
</style>

<script>
import { Empty, Panel, Cell, CellGroup, Image, List, Row, Col } from "vant";
import moment from "moment";
import util from 'libs/utils';
export default {
  filters:{
    diffentTime(diffValue, Value) {
      if(!Value) return '- -'

      if (diffValue < 0) {
        console.log('时间不对劲,服务器创建时间与当前时间不同步');
        return '刚刚';
      }
      if (diffValue < 60) {
        return '刚刚';
      }
      let dur = moment.duration(diffValue * 1000);
      if (diffValue > 60 && diffValue < 3600) {
        return dur.minutes() + '分钟前';
      }

      if (diffValue > 3600 && diffValue < 86400) {
        return dur.hours() + '小时前';
      }
      return moment(Value * 1000).format('MM-DD HH:mm');
    },
    SportsItemtype(value){
      switch(+value){
        case 2:
          return '个';
          break;
        default:
          return '';
          break;
      }
    }
  },
  computed: {
    borderRadius() {
      if (this.filter) {
        let i = this.filter.findIndex((row) => {
          return row.active == 1;
        });
        if (i == 0) {
          return "0 .2rem .2rem .2rem";
        } else {
          return ".2rem";
        }
      }
    },
  },
  components: {
    Empty,
    Panel,
    Cell,
    CellGroup,
    List,
    VanImage: Image,
    Row,
    Col,
  },
  data() {
    return {
      rankList: [],
      loading: false,
      finished: false,
      detail: "",
      page: 1,
      systime: "",
      myinfo: "",
      register_type: "",
      filter: [],
      type: "",
      physical_item_id: 0,
      item_sub_id: '',
      item_id: ''
    };
  },
  methods: {
    onChange(row) {
      if (this.loading) return;
      this.filter.forEach((item) => {
        item.active = 0;
      });
      row.active = 1;
      this.register_type = row.value;
      this.rankList = [];
      this.page = 1;
      this.getRankList();
    },
    filername(name){
      console.log(name,this.myinfo,'name')
      let val = util.hc(name,6)
      switch(val*1){
        case 0:
          return '#B9C5D1';
        case 1:
          return '#D2C1B9';
        case 2:
          return '#BAB3C6';
        case 3:
          return '#D3BFC8';
        case 4:
          return '#D0CAB2';
        case 5:
          return '#B6C3B2';
      }
    },
    getRankList: function () {
      //如果为空or 0 按照 item_id  rank
      if (!+this.item_sub_id) {
        this.$api.sports
          .sportsItemRank({ itemid: this.item_id, page: this.page })
          .then((res) => {
            let { page, list } = res.data;
            this.systime = res.sys_time;
            this.loading = false;
            if (+page.currentPage === 1) {
              this.rankList = list;
            } else {
              this.rankList = this.rankList.concat(list);
            }

            let t = null

            this.rankList.forEach((item, index) => {
              item = Object.assign(item, item.userInfo);
              item.score = +item.total_score ? item.total_score : 0;
                if(t == null){
                    t =  item;
                    t.rank = index+1;
                }else{
                    var n = item;
                    if(n.score*1 == t.score*1){
                        n.rank = t.rank;
                    }else{
                          n.rank = index+1;
                    }
                    t = n;
                }
            })

            if (+page.currentPage >= page.pageCount) {
              this.finished = true;
            } else {
              this.page++;
            }
          });
      } else {
        if(this.$route.query.rank_type==2){
          this.$api.sports
          .compareRankAll(
            Object.assign({
              cpgid: this.item_sub_id,
              page: this.page,
              sort: 2,
              register_type: this.register_type,
            })
          )
          .then((res) => {
            if (+res.status !== 200) {
              this.finished = true;
              return;
            }
            this.systime = res.sys_time;
            this.loading = false;
            let {
              list,
              page,
              pages,
              myinfo,
              type,
            } = res.data;
            this.myinfo = myinfo;
            this.type = type;
            this.filter = res.data.filter;
            if (page == 1) {
              this.rankList = list;
            } else {
              this.rankList = this.rankList.concat(list);
            }

            let t = null

            this.rankList.forEach((item, index) => {
                if(t == null){
                    t =  item;
                    t.rank = index+1;
                }else{
                    var n = item;
                    if(n.score*1 == t.score*1){
                        n.rank = t.rank;
                    }else{
                          n.rank = index+1;
                    }
                    t = n;
                }
            })

            if (page >= pages) {
              this.finished = true;
            } else {
              this.page++;
            }
          });
        } else {
          this.$api.sports
          .compareRank2(
            Object.assign({
              cpgid: this.item_sub_id,
              page: this.page,
              sort: 2,
              register_type: this.register_type,
            })
          )
          .then((res) => {
            if (+res.status !== 200) {
              this.finished = true;
              return;
            }
            this.systime = res.sys_time;
            this.loading = false;
            let {
              list,
              page,
              pages,
              myinfo,
              type,
            } = res.data;
            this.myinfo = myinfo;
            this.type = type;
            this.filter = res.data.filter;
            if (page == 1) {
              this.rankList = list;
            } else {
              this.rankList = this.rankList.concat(list);
            }

            let t = null

            this.rankList.forEach((item, index) => {
                if(t == null){
                    t =  item;
                    t.rank = index+1;
                }else{
                    var n = item;
                    if(n.score*1 == t.score*1){
                        n.rank = t.rank;
                    }else{
                          n.rank = index+1;
                    }
                    t = n;
                }
            })

            if (page >= pages) {
              this.finished = true;
            } else {
              this.page++;
            }
          });
        }
          
      }
    },
    init: function () {
      this.$toast.loading({
        duration: 0,
      });
      let params = { cpgid: this.item_sub_id };
      this.$toast.clear();
    },
  },
  mounted() {
	  this.item_sub_id = this.$route.params.item_sub_id
    this.sports_id = this.$route.params.acid
    this.item_id = this.$route.params.item_id
    this.init();
    // this.getRankList();
  },
};
</script>
